module.exports = __webpack_public_path__ + "img/3.ee684d04.png";